module.exports = __webpack_public_path__ + "static/mr-concert-performance-25-f4f791b36b7dbe6c04ec8252e789bb29.jpg";